import { Box, Chip } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getTemplateVariables } from '@/services/notificationService'

type Props = { accountId: number; onInsert: (variable: string) => void }

const TemplateVariablePalette = ({ accountId, onInsert }: Props) => {
  const { data } = useQuery({
    queryKey: ['template-variables', accountId],
    queryFn: () => getTemplateVariables(accountId),
    staleTime: 5 * 60 * 1000,
  })
  if (!data || data.length === 0) return null
  return (
    <Box sx={{ direction: 'rtl', display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {data.map(v => (
        <Chip
          key={v.variable}
          className="nodrag"
          label={v.label}
          size="small"
          onClick={() => onInsert(v.variable)}
        />
      ))}
    </Box>
  )
}

export default TemplateVariablePalette
